export default __webpack_public_path__ + "static/worker5-b60ba4c0802f74b228476f89569d4767.jpeg";